import React, { useEffect, useState } from 'react';
import { Button, Card, CardFooter, Col, Row } from 'reactstrap';
import { useFormik } from 'formik';
import * as Icon from 'react-feather';
import FormSelect from '../../../components/form/FormSelect';
import { useDispatch } from 'react-redux';
import { processAllOptionGet } from '../../../store/slices/tenantSlices/dailyReportSlice';
import AdminHeader from '../../../components/header/AdminHeader';
import Pagination from '../../../components/form/Pagination';
import CallexLoader from '../../../components/CallexLoader';
import FormInput from '../../../components/form/FormInput';
import {
  dispositionDelete,
  dispositionListGet,
  useDispositionList
} from '../../../store/slices/tenantSlices/settingSlice';
import AddEditDispositionModal from './AddEditDispositionModal';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';
import { toast } from 'react-toastify';
import { checkModulePermission } from '../../../utils/common';
import { useUserRolePermission } from '../../../store/slices/authSlice';
import CopyDispositionModal from './CopyDispositionModal';

const Disposition = () => {
  const dispatch = useDispatch();
  const dispositionList = useDispositionList();
  const userRolePermission = useUserRolePermission();

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [processOptions, setProcessOptions] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openCopyModal, setOpenCopyModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);

  const initialValues = {
    page: 1,
    limit: 10,
    search: '',
    process_id: ''
  };

  const handleFormSubmit = async (reset = false) => {
    setIsLoading(true);
    setIsFilterOpen(false);
    try {
      const payload = { ...values };
      if (reset === true) {
        payload['process_id'] = '';
        payload['search'] = '';
      }
      await dispatch(dispositionListGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  };

  const { values, handleChange, handleBlur, setFieldValue, handleSubmit, touched, errors } =
    useFormik({
      initialValues,
      onSubmit: handleFormSubmit
    });

  useEffect(() => {
    handleFormSubmit();
  }, [values?.limit, values?.page]);

  const getProcessOption = async (id) => {
    try {
      const response = await dispatch(processAllOptionGet({ crm_id: id })).unwrap();
      if (response && response.data) {
        const options = response.data.map((val) => ({
          label: val.name,
          value: val.id
        }));
        setProcessOptions(options);
      } else {
        setProcessOptions([]);
      }
    } catch (error) {
      setProcessOptions([]);
      console.log('error', error);
    }
  };

  useEffect(() => {
    getProcessOption();
  }, []);

  const deleteDispo = async () => {
    try {
      const response = await dispatch(dispositionDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        handleFormSubmit();
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div>
      <AdminHeader
        title="Disposition"
        isSearch
        isAddDisabled={!checkModulePermission('is_add', 'Disposition', userRolePermission)}
        onSearchClick={() => setIsFilterOpen(!isFilterOpen)}
        isAdd
        isCopy
        copyBtnName="Copy Disposition"
        addBtnName="Add Disposition"
        onAddClick={() => setOpenAddModal(true)}
        onCopyClick={() => setOpenCopyModal(true)}
      />
      {isFilterOpen && (
        <Card className="mb-3 p-3">
          <form onSubmit={handleSubmit}>
            <Row>
              <Col lg="3" md="3" className="flex-row">
                <FormInput
                  name="search"
                  label="Search"
                  placeholder="Search here"
                  value={values.search}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  touched={touched}
                  errors={errors}
                />
              </Col>
              <Col lg="3" md="2" className="flex-row">
                <FormSelect
                  label="Process"
                  placeholder="Select Process"
                  value={values.process_id}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="process_id"
                  options={processOptions}
                  touched={touched}
                  errors={errors}
                />
              </Col>
            </Row>
            <CardFooter className="p-0 bg-white text-end">
              <Button
                className="px-4 me-4 bg-transparent text-primary"
                onClick={() => {
                  handleFormSubmit(true);
                  setFieldValue('search', '');
                  setFieldValue('process_id', '');
                }}>
                Clear
              </Button>
              <Button color="primary" className="px-4" type="submit">
                Search
              </Button>
            </CardFooter>
          </form>
        </Card>
      )}
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: isFilterOpen ? 'calc(100vh - 328px)' : 'calc(100vh - 165px)' }}>
          <CallexLoader />
        </Card>
      ) : dispositionList?.data?.length > 0 &&
        checkModulePermission('is_view', 'Disposition', userRolePermission) ? (
        <Card className="p-0 position-relative">
          <div
            className="daily-report-table"
            style={{ height: isFilterOpen ? 'calc(100vh - 369px)' : 'calc(100vh - 208px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Disposition Code</th>
                  <th>Disposition Name</th>
                  <th>Process Name</th>
                  <th>Active</th>
                  <th className="text-center" style={{ width: '90px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {dispositionList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.DisposCode}</td>
                      <td>{val?.DisposName}</td>
                      <td>{val?.ProcessName}</td>
                      <td>{String(val?.active)}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div
                            className={`cursor-pointer text-info ${
                              !checkModulePermission('is_edit', 'Disposition', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission(
                                    'is_edit',
                                    'Disposition',
                                    userRolePermission
                                  )
                                ) {
                                  setEditRecord(val);
                                  setIsEdit(true);
                                  setOpenAddModal(true);
                                }
                              }}
                            />
                          </div>
                          <div
                            className={`cursor-pointer text-danger ${
                              !checkModulePermission('is_delete', 'Disposition', userRolePermission)
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission(
                                    'is_delete',
                                    'Disposition',
                                    userRolePermission
                                  )
                                ) {
                                  setIsDeleteId(val?.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="position-absolute w-100" style={{ bottom: '-56px' }}>
            <Pagination
              totalCount={dispositionList?.total}
              limit={dispositionList?.limit}
              page={dispositionList?.page}
              onLimitChange={(val) => {
                setFieldValue('limit', val);
                setFieldValue('page', 1);
              }}
              onPageClick={(val) => setFieldValue('page', val)}
              lastPageClick={(val) => setFieldValue('page', val)}
              firstPageClick={(val) => setFieldValue('page', val)}
              onRefreshClick={() => handleFormSubmit()}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: isFilterOpen ? 'calc(100vh - 328px)' : 'calc(100vh - 165px)' }}>
          No data available
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteDispo()}
      />
      <AddEditDispositionModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            handleFormSubmit();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
      {openCopyModal && (
        <CopyDispositionModal
          isOpen={openCopyModal}
          onCloseClick={(apiCall = false) => {
            setOpenCopyModal(false);
            if (apiCall) {
              handleFormSubmit();
            }
          }}
        />
      )}
    </div>
  );
};

export default Disposition;
